import { RouteRecordRaw } from "vue-router";

const Jobs: RouteRecordRaw = {
  path: "jobs",
  component: () => import("@/views/public/index.vue"),
  meta: {
    title: "Jobs",
  },
  children: [
    {
      path: "",
      alias: "index",
      name: "job",
      component: () => import("@/views/public/jobs/pages/index.vue"),
      meta: {
        pageId: 18010400,
        role: "view",
        title: "Jobs",
      },
    },
    {
      path: "add",
      name: "Add New job",
      component: () => import("@/views/public/jobs/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "add",
        title: "AddNew",
      },
    },
    {
      path: "Edit/:Id",
      props: true,
      name: "Edit job",
      component: () => import("@/views/public/jobs/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "edit",
        title: "Edit",
      },
    },
  ],
};

export default Jobs;
